import type {LocalizationContextType} from 'localization/context/types';
import {makeSearchableTaskString} from 'scenes/overview/functions';
import {mergeDuplicateManifestations} from 'scenes/overview/mapper/mapOverviewTask';
import type {OverviewTask, TaskV2} from '../types';

const mapTaskV2ToOverviewTask = (
  tasks: TaskV2[],
  localization: LocalizationContextType,
): OverviewTask[] => {
  const overviewTasks: OverviewTask[] = tasks.map(
    ({type, metadata, ...rest}) => {
      const {
        publisherSalesDate,
        contentReceivedDate,
        inSaleDate,
        productOwner,
        ...restMetadata
      } = metadata;

      return {
        taskTypes: [type],
        // On part type="date" DataValue is string, not date.
        publisherSalesDate: publisherSalesDate ?? undefined, //: publisherSalesDate?.toUTCString(),
        contentReceivedDate: contentReceivedDate ?? undefined, //: contentReceivedDate?.toUTCString(),
        inSaleDate: inSaleDate ?? '', //: inSaleDate?.toUTCString(),
        // Duplicated to be filterable but not visible
        productOwner: productOwner,
        productOwnerName: productOwner ? productOwner.name : undefined,
        productOwnerCode: productOwner ? productOwner.code : undefined,
        ...rest,
        ...restMetadata,
        searchableTaskString: '',
      };
    },
  );
  overviewTasks.forEach(task => {
    task.searchableTaskString = makeSearchableTaskString(task, localization);
  });
  return overviewTasks;
};

const filterTasksWithOnlyMlSuggestions = (
  tasks: OverviewTask[],
): OverviewTask[] => {
  return tasks.filter(t => {
    return !(t.taskTypes.length === 1 && t.taskTypes[0] === 'ml');
  });
};

export const mapTasksToOverviewTasks = (
  tasks: TaskV2[],
  localization: LocalizationContextType,
): OverviewTask[] => {
  return filterTasksWithOnlyMlSuggestions(
    mergeDuplicateManifestations(mapTaskV2ToOverviewTask(tasks, localization)),
  );
};
